import React, { FunctionComponent, memo, useMemo } from "react"
import { classNames } from "utils"
import { ListItemV2, TypographyV2 } from "components/v2"
import { useTranslation } from "react-i18next"
interface ListV2<T> {
    filterQuery?: string
    isVerticalView?: boolean
    renderItem: FunctionComponent<T>
    list: T[]
    filterFunction?: (item: T) => boolean
    listItemClassName?: string
}

function ListV2<T>({
    list,
    renderItem: RenderItem,
    listItemClassName,
    isVerticalView = false,
    filterFunction,
    ...otherProps
}: ListV2<T>) {
    const filteredList = useMemo(
        () => (filterFunction ? list?.filter((item) => filterFunction(item)) : list),
        [list, filterFunction]
    )

    const { t } = useTranslation()

    if (filteredList?.length === 0) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <TypographyV2 type="xs" width="bold">
                    {t("no_results_found", { ns: "common" })}
                </TypographyV2>
            </div>
        )
    }

    return (
        <div className={classNames(isVerticalView ? "flex-col" : "flex-row", "flex flex-wrap justify-start gap-2")}>
            {filteredList?.map((item, idx) => (
                <ListItemV2 key={idx} className={listItemClassName} isVerticalView={isVerticalView}>
                    <RenderItem {...{ ...item, ...otherProps, isVerticalView }} />
                </ListItemV2>
            ))}
        </div>
    )
}

export default memo(ListV2)
